import type { HTMLAttributes } from "react";
import "./VisuallyHidden.css";

/** Text for screen readers only. */
export function VisuallyHidden({ className, ...rest }: HTMLAttributes<HTMLSpanElement>) {
  return <span className={className ? `ui-visually-hidden ${className}` : "ui-visually-hidden"} {...rest} />;
}
